(() => {
  const desktop = matchMedia('(min-width: 990px)');
  const init = (root = document) => root.querySelectorAll('.product__outer').forEach(outer => {
    if (outer.dataset.stellarLayoutReady) return;
    const galleryColumn = outer.querySelector('.stellar-product-gallery-column');
    const gallery = galleryColumn?.querySelector(':scope > .product__media-wrapper');
    const infoWrapper = outer.querySelector('.product__info-wrapper');
    const info = infoWrapper?.querySelector('.product__info-container');
    const related = galleryColumn?.querySelector(':scope > .stellar-related-products');
    if (!gallery || !info || !related || !window.ResizeObserver) return;
    outer.dataset.stellarLayoutReady = 'true';
    let frame = 0;
    let originalBreakpoints;
    let placement = '';
    const measure = () => {
      frame = 0;
      const galleryHeight = gallery.getBoundingClientRect().height;
      const infoHeight = info.getBoundingClientRect().height;
      const available = galleryHeight - infoHeight - 24;
      // Prefer the shorter right column when it has a useful space below purchasing.
      // Larger recommendation images may extend below the gallery without moving the row left.
      const onRight = desktop.matches && available >= (placement === 'right' ? 144 : 160);
      const near = !onRight && desktop.matches && galleryHeight > 0 && Math.abs(infoHeight - galleryHeight) <= Math.min(160, galleryHeight * .2);
      const nextPlacement = onRight ? 'right' : near ? 'wide' : 'left';
      const changed = placement !== nextPlacement;
      placement = nextPlacement;
      if (onRight) {
        if (related.parentElement !== infoWrapper) infoWrapper.append(related);
        related.classList.add('stellar-related-right');
        const infoStyle = getComputedStyle(info);
        related.style.setProperty('--stellar-related-inset-left', infoStyle.paddingLeft);
        related.style.setProperty('--stellar-related-inset-right', infoStyle.paddingRight);
        outer.classList.remove('stellar-related-wide');
        const media = related.querySelector('.card--product .media');
        const mediaHeight = media?.getBoundingClientRect().height || 220;
        const overhead = related.getBoundingClientRect().height - mediaHeight;
        const target = Math.max(120, Math.min(220, Math.floor(available - overhead)));
        const value = target + 'px';
        if (related.style.getPropertyValue('--stellar-related-media-height') !== value) related.style.setProperty('--stellar-related-media-height', value);
      } else {
        if (related.parentElement !== galleryColumn) galleryColumn.append(related);
        related.classList.remove('stellar-related-right');
        related.style.removeProperty('--stellar-related-media-height');
        outer.classList.toggle('stellar-related-wide', near);
      }
      const slider = related.querySelector('.swiper')?.swiper;
      if (slider && (changed || !originalBreakpoints)) {
        originalBreakpoints ||= slider.params.breakpoints;
        slider.params.breakpoints = near ? {...originalBreakpoints, 990:{slidesPerView:3,spaceBetween:16},1200:{slidesPerView:4,spaceBetween:24}} : originalBreakpoints;
        slider.currentBreakpoint = undefined;
        slider.setBreakpoint();
        slider.update();
      }
      related.querySelectorAll('.product-card').forEach(card => {
        const image = card.querySelector('.card--product .media');
        if (!image) return;
        const width = image.getBoundingClientRect().width + 'px';
        if (card.style.getPropertyValue('--stellar-related-card-width') !== width) card.style.setProperty('--stellar-related-card-width', width);
      });
      const titles = [...related.querySelectorAll('.card__title')];
      titles.forEach(title => { title.style.minHeight = '0px'; });
      const titleHeight = Math.max(0, ...titles.map(title => title.getBoundingClientRect().height));
      titles.forEach(title => { title.style.minHeight = titleHeight + 'px'; });
      const media = related.querySelector('.card--product .media');
      if (media) {
        const offset = media.getBoundingClientRect().top - related.querySelector('.swiper').getBoundingClientRect().top + media.getBoundingClientRect().height / 2;
        related.style.setProperty('--stellar-related-arrow-top', offset + 'px');
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
    const observer = new ResizeObserver(schedule);
    observer.observe(gallery);
    observer.observe(info);
    observer.observe(related);
    desktop.addEventListener('change', schedule);
    const section = outer.closest('.shopify-section');
    const unload = event => {
      if (event.target !== section) return;
      observer.disconnect();
      desktop.removeEventListener('change', schedule);
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    schedule();
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
// Reveal mobile product accordion content below a visible summary.
(() => {
  document.addEventListener("click", event => {
    if (!matchMedia("(max-width:989px)").matches || !document.body.classList.contains("template-product")) return;
    const summary = event.target.closest("#MainContent details > summary");
    const detail = summary?.parentElement;
    if (!detail || detail.open || summary.closest("dialog")) return;
    requestAnimationFrame(() => {
      if (!detail.open) return;
      const header = document.querySelector(".header-wrapper");
      const inset = Math.min(180, (header?.getBoundingClientRect().height || 0) + 16);
      const delta = summary.getBoundingClientRect().top - inset;
      if (Math.abs(delta) > 24) window.scrollBy({top:delta,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches ? "instant" : "smooth"});
    });
  });
})();
